import { ZoneService } from "./../_services/zone.service";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatSort } from "@angular/material/sort";
import { MatPaginator } from "@angular/material/paginator";
import { Component, OnInit, ViewChild } from "@angular/core";
import { MatTableDataSource } from "@angular/material/table";
import { Router } from "@angular/router";
import { CourierService } from "../_services/courier.service";
import { Zone } from "../_models/zone";

@Component({
  selector: "app-zone-list-page",
  templateUrl: "./zone-list-page.component.html",
  styleUrls: ["./zone-list-page.component.scss"],
})
export class ZoneListPageComponent implements OnInit {
  constructor(
    public snackBar: MatSnackBar,
    private router: Router,
    public courierService: CourierService,
    public zoneService: ZoneService
  ) { }

  displayedColumns = ["Id", "Name", "CurrencyCode", "formatCourier", "formatActive"];
  dataSource: MatTableDataSource<Zone>;
  isDataLoaded = false;
  public couriers: any = {};

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  ngOnInit(): void {
    this.dataSource = new MatTableDataSource<Zone>();
    this.courierService.getCouriers().subscribe(
      (couriers) => {
        couriers.forEach((courier) => {
          this.couriers[courier.id] = courier.name;
        });
      },
      (err) => {
        this.showErrorMessage("Error retrieving couriers");
      }
    );
    this.zoneService.getZones().subscribe(
      (zones: Zone[]) => {
        this.dataSource.data = zones.map((zone) => { 
          zone.formatCourier = this.couriers[zone.courierId];
          zone.formatActive = zone.active ? 'Active' : 'Inactive';
          return zone;
        });
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
        this.isDataLoaded = true;
      },
      (err) => {
        if (err.status == 404) {
          this.dataSource.data = [];
        }
        this.isDataLoaded = true;
      }
    );
  }

  public showErrorMessage(message): void {
    this.snackBar.open(message, "Error", {
      duration: 2000,
    });
  }

  applyFilter(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
    this.dataSource.filter = filterValue;
  }

  addState() {
    this.router.navigate(["regional", "zones", "add"]);
  }

  viewState(id: number) {
    this.router.navigate(["regional", "zones", id]);
  }
}
